import constants from '../constants'

/* eslint-disable linebreak-style */
export default (state = {}, action) => {
  switch (action.type) {
    case constants.CMS_LIST:
      return {
        ...state,
        cmsList: action.payload.data,
        resStatus: action.payload.resStatus,
        resMessage: action.payload.resMessage
      }
    case constants.CMS_DETAILS:
      return {
        ...state,
        cmsDetails: action.payload.data,
        resStatus: action.payload.resStatus,
        resMessage: action.payload.resMessage
      }
    case constants.EDIT_CMS_DETAILS:
      return {
        ...state,
        resStatus: action.payload.resStatus,
        resMessage: action.payload.resMessage
      }
    case constants.DELETE_CMS_DETAILS:
      return {
        ...state,
        resStatus: action.payload.resStatus,
        resMessage: action.payload.resMessage
      }
    case constants.ADD_CMS_DETAILS:
      return {
        ...state,
        // cmsDetails: action.payload.data,
        resStatus: action.payload.resStatus,
        resMessage: action.payload.resMessage
      }
    case constants.CLEAR_CMS_MESSAGE:
      return {
        resMessage: ''
      }
    case constants.CLEAR_USER_PROPS:
      return {
        cmsList: {},
        resStatus: false,
        resMessage: ''
      }
    default:
      return state
  }
}
